export const CA_ROLES = {
    5: 'Admin',
    10: 'HR'
}
